import { PluginObject } from 'vue'
import MD5 from 'md5.js'

const plugins: PluginObject<unknown> = {
  install (Vue) {
    // 千分符
    Vue.prototype.$thousandNum = function (num: number) : string {
      return String(num).replace(/\d+/, function (n) { // 先提取整数部分
        return n.replace(/(\d)(?=(\d{3})+$)/g, function ($1) { // 对整数部分添加分隔符
          return $1 + ','
        })
      })
    }
    // 计算精度问题
    Vue.prototype.$precision = (num: number): number => {
      if (typeof num !== 'number') {
        console.error('请传入一个 number 类型的数据，而不是一个 ' + typeof num)
        return num
      }
      return Math.floor(num * 100) / 100
    }
    /**
     * @description: MD5加密
     * @return {string} 加密后的值
     * @example 使用方法 new this.$md5
     *  参数说明-> https://www.npmjs.com/package/md5.js
     */
    Vue.prototype.$md5 = MD5
    Vue.prototype.$sign = 'MllOeDBoVTdzSA==' // 2YNx0hU7sH ->原生秘钥    现在记录的是base64后的秘钥
    Vue.prototype.$secretKey = (): string => { // 转换过后的秘钥   不直接显示出来是考虑安全问题
      return window.atob(Vue.prototype.$sign)
    }
  }
}

export default plugins

declare module 'vue/types/vue' {
  interface Vue {
    $precision(num: number): number;
    $thousandNum(num: number): string;
    $md5: any;
    $secretKey(): string
  }
}
